import {
  background,
  border,
  brand,
  neutral,
  semantic,
  system,
  text,
} from "./colors";

export const lightTheme = {
  primary: brand.primary.main,
  primaryLight: brand.primary.light,
  primaryLighter: brand.primary.lighter,
  primaryDark: brand.primary.dark,
  primaryFaded: brand.primary.faded,

  success: semantic.success.main,
  successLight: semantic.success.light,
  successDark: semantic.success.dark,
  successBackground: semantic.success.background,

  warning: semantic.warning.main,
  warningLight: semantic.warning.light,
  warningDark: semantic.warning.dark,
  warningBackground: semantic.warning.background,

  error: semantic.error.main,
  errorLight: semantic.error.light,
  errorDark: semantic.error.dark,
  errorBackground: semantic.error.background,

  info: semantic.info.main,
  infoLight: semantic.info.light,
  infoDark: semantic.info.dark,
  infoBackground: semantic.info.background,

  text: text.primary,
  textSecondary: text.secondary,
  textTertiary: text.tertiary,
  textDisabled: text.disabled,
  textInverse: text.inverse,

  background: background.primary,
  backgroundSecondary: background.secondary,
  backgroundTertiary: background.tertiary,
  backgroundDisabled: background.disabled,

  border: border.primary,
  borderSecondary: border.secondary,
  borderThird: border.third,

  systemBlue: system.blue,
  systemRed: system.red,
  systemGreen: system.green,
  systemYellow: system.yellow,
  systemOrange: system.orange,
  systemPurple: system.purple,
};

export const darkTheme: typeof lightTheme = {
  primary: brand.primary.main,
  primaryLight: brand.primary.dark,
  primaryLighter: brand.primary.darker,
  primaryDark: brand.primary.light,
  primaryFaded: brand.primary.faded,

  success: semantic.success.main,
  successLight: semantic.success.dark,
  successDark: semantic.success.light,
  successBackground: semantic.success.background,

  warning: semantic.warning.main,
  warningLight: semantic.warning.dark,
  warningDark: semantic.warning.light,
  warningBackground: semantic.warning.background,

  error: semantic.error.main,
  errorLight: semantic.error.dark,
  errorDark: semantic.error.light,
  errorBackground: semantic.error.background,

  info: semantic.info.main,
  infoLight: semantic.info.dark,
  infoDark: semantic.info.light,
  infoBackground: semantic.info.background,

  text: neutral[50],
  textSecondary: neutral[200],
  textTertiary: neutral[400],
  textDisabled: neutral[600],
  textInverse: neutral[900],

  background: "#0D0F12",
  backgroundSecondary: "#1A1D23",
  backgroundTertiary: "#252A33",
  backgroundDisabled: neutral[600],

  border: "#2D333D",
  borderSecondary: "#3A4250",
  borderThird: "#4B5563",

  systemBlue: system.blue,
  systemRed: system.red,
  systemGreen: system.green,
  systemYellow: system.yellow,
  systemOrange: system.orange,
  systemPurple: system.purple,
};
export type Theme = typeof lightTheme;
export type ThemeColors = keyof Theme;
